module.exports = __webpack_public_path__ + "static/media/banner-area-2.eafb2317.png";